import { render, staticRenderFns } from "./DialogOther.vue?vue&type=template&id=2de82fd6&"
import script from "./DialogOther.vue?vue&type=script&lang=js&"
export * from "./DialogOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports